import VueI18n from 'vue-i18n' //引入vue-i18n组件
import messages from './index'
import Vue from 'vue'
Vue.use(VueI18n)
var lang = (
  (navigator.language ? navigator.language : navigator.userLanguage) || "zh"
).toLowerCase();
if(lang.split("-")[0]=="zh"){
  lang="zh"
}else{
  lang="en"
}
const language=lang;
const i18n = new VueI18n({
  fallbackLocale: 'zh',
  silentFallbackWarn:true, 
  locale: language,//默认显示的语言 

  messages,//本地化的语言环境信息。
});


export default i18n


// WEBPACK FOOTER //
// ./src/lang/i18n.js